"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellDate = function CellDate(props) {
  var cellValue = props.row[props.col.key];
  var dateToRender = '--';

  if (cellValue && cellValue.length) {
    var momentValue = (0, _moment.default)(cellValue);

    if (_moment.default.isMoment(momentValue)) {
      dateToRender = momentValue.format('M/D/YYYY h:mm:ss a');
    }
  }

  return _react.default.createElement("div", {
    "data-cw-grid-cell-text": true,
    className: _CwDataGrid.default.cell,
    title: dateToRender,
    style: {
      width: props.col.width
    }
  }, dateToRender);
};

CellDate.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired
};
var _default = CellDate;
exports.default = _default;